import { memo, useMemo } from 'react'
import { useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { useKindeAuth } from '@kinde-oss/kinde-auth-react'
import { blueGrey } from '@mui/material/colors'
import Divider from '@mui/material/Divider'
import { Box } from '@mui/system'
import PropTypes from 'prop-types'

import { useGetOrderQuery } from '@/app/services/orders'
import { selectOrganisationId, selectPaidFeatures } from '@/app/slices/organisationSlice'

import OrderStatusChip from '../common/OrderStatusChip'

import OrderCustomerContact from './OrderCustomerContact'
import OrderDetailsOptions from './OrderDetailsOptions'
import OrderNotes from './OrderNotes'

const classes = {
    content: {
        backgroundColor: 'background.paper',
        borderRadius: 2,
        border: `1px solid ${blueGrey[200]}`,
        width: '100%',
        padding: 3,
    },

    divider: {
        borderStyle: 'dashed',
        borderColor: blueGrey[200],
    },
}
const OrderHeader = ({ hideCustomerContact = false }) => {
    const { orderId } = useParams()

    const { isAuthenticated } = useKindeAuth()

    const organisationId = useSelector(selectOrganisationId)
    const paidFeatures = useSelector(selectPaidFeatures)

    const { data: order } = useGetOrderQuery({
        organisationId,
        orderId,
    })

    const orderStatus = useMemo(() => order?.status, [order])

    return (
        <Box
            sx={[
                {
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 3,
                },
                classes.content,
            ]}
        >
            <Box
                sx={{
                    alignItems: 'center',
                    display: 'flex',
                    justifyContent: 'space-between',
                }}
            >
                <Box
                    sx={{
                        display: 'flex',
                        gap: 1,
                    }}
                >
                    <OrderStatusChip
                        key={`${order?.id}-status-chip`}
                        orderStatus={orderStatus}
                    />
                </Box>

                <Box
                    sx={{
                        display: 'flex',
                        gap: 1,
                    }}
                >
                    {!paidFeatures?.isFreePlan ? <OrderNotes key={`${order?.id}-notes`} /> : null}
                </Box>
            </Box>

            <Box
                sx={{
                    alignItems: 'center',
                    display: 'flex',
                    gap: 3,
                }}
            >
                {isAuthenticated && !hideCustomerContact ? (
                    <>
                        <OrderCustomerContact
                            key={`${order?.id}-customer-contact`}
                            order={order}
                        />

                        <Divider
                            orientation="vertical"
                            sx={classes.divider}
                            flexItem
                        />
                    </>
                ) : null}

                <OrderDetailsOptions
                    key={`${order?.id}-details-options`}
                    order={order}
                />
            </Box>
        </Box>
    )
}

OrderHeader.propTypes = {
    hideCustomerContact: PropTypes.bool,
}

export default memo(OrderHeader)
